import styled from "styled-components";

export const ModalCard = styled.span`
  width: 24.375rem;
  /* height: 33.25rem; */
  background: #fff;
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
  position: relative;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 20.375rem;
  }
`;
export const CardHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  h2 {
    color: #3f3f3f;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
export const Button = styled.button`
  width: 100%;
  height: 2.25rem;
  border-radius: 0.25rem;
  background: #351182;
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const Input = styled.input`
  color: #a9a9a9;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  height: 2.875rem;
  border-radius: 0.5625rem;
  border: 1px solid #d1d1d1;
  background: #fff;
  margin-bottom: 1.5rem;
  padding: 0.5rem 1rem;
`;
